import React from 'react';
import { ShieldCheckIcon, CheckCircle } from 'lucide-react';
import { motion } from 'framer-motion';
export const GuaranteeSection: React.FC = () => {
  const guarantees = [{
    title: 'Geen resultaat? Geen factuur.',
    body: 'Als we de afgesproken doelstellingen niet halen in de eerste 90 dagen, betaal je niets extra.'
  }, {
    title: 'Onbeperkte revisierondes.',
    body: 'We blijven aanpassen tot het klopt. Geen maximum aantal correcties, en geen meerwerkfactuur omdat je onderweg van gedachten verandert.'
  }, {
    title: 'Altijd bereikbaar, altijd eerlijk.',
    body: 'Je krijgt een vaste contactpersoon, directe communicatie en nooit een verrassingsrekening.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative w-full py-[100px] bg-[#1F222C] overflow-hidden flex justify-center" data-id="element-456" data-mp="25pkkhr9gjlcy">
      {/* Subtle blue glow/gradient on the sides */}
      <div className="absolute left-[-200px] top-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#004AC7] opacity-[0.15] blur-[150px] rounded-full pointer-events-none" data-id="element-457" data-mp="1vuit0orpm777" />
      <div className="absolute right-[-200px] top-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#004AC7] opacity-[0.15] blur-[150px] rounded-full pointer-events-none" data-id="element-458" data-mp="2oiy635ra6ffw" />

      <div className="relative z-10 w-full max-w-[1100px] px-4 md:px-6 flex flex-col items-center text-center" data-id="element-459" data-mp="2jlo831ptsvgg">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mb-6" data-id="element-460" data-mp="2ar02tbk93drn">
          <ShieldCheckIcon size={80} color="#007AFF" strokeWidth={1.5} data-id="element-461" data-mp="10kno23qdygp1" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} className="text-white font-bold text-3xl sm:text-4xl md:text-[48px] leading-tight mb-4 break-words hyphens-auto px-2 max-w-full" style={{
        fontFamily: 'Inter, sans-serif'
      }} lang="nl" data-id="element-462" data-mp="10n058eobkn11">
          100% Tevredenheidsgarantie
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-white text-lg md:text-[20px] max-w-3xl leading-relaxed mb-16" data-id="element-463" data-mp="7wrq6vp2yiqo">
          Wij leveren resultaat. Lukt dat niet, dan lossen we het op. Geen
          smoesjes, geen verstoppertje spelen. Gewoon doen wat we beloven.
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full text-left mb-16 items-stretch" data-id="element-464" data-mp="3mtv4ynbgkzkb">
          {guarantees.map((guarantee, index) => <motion.div key={index} variants={itemVariants} className="bg-[#2a2f3d] rounded-2xl p-8 border border-white/5 shadow-xl flex flex-col" data-id="element-465" data-mp="eaxballopi0g" data-mpi={index}>
              <CheckCircle className="w-8 h-8 text-[#007AFF] mb-6 flex-shrink-0" data-id="element-466" data-mp="oaefeylafnub" />
              <h3 className="text-white font-semibold text-xl mb-3" data-id="element-467" data-mp="o822izue03o4">
                {guarantee.title}
              </h3>
              <p className="text-white/70 leading-relaxed text-base" data-id="element-468" data-mp="2q1j71un80oen">
                {guarantee.body}
              </p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.4,
        ease: 'easeOut'
      }} data-id="element-469" data-mp="2l4ssjbr2e0vc">
          <a href="#contact" className="inline-block bg-[#004AC7] text-white px-[32px] py-[16px] rounded-[8px] font-medium text-lg hover:bg-[#003da6] transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 duration-200" data-id="element-470" data-mp="2wikt7hqyysh3">
            Plan een kennismaking &rarr;
          </a>
        </motion.div>
      </div>
    </section>;
};